export default __webpack_public_path__ + "static/media/Shalimar-Regular.9a1770eb.woff";